<template>
  <div class="revenue-charts row mb-4">
    <div class="col-md-8">
      <div class="card h-100">
        <div class="card-header bg-white font-weight-bold">
          <i class="fas fa-chart-area mr-1"></i> Biểu đồ doanh thu & lợi nhuận hàng ngày
        </div>
        <div class="card-body">
          <line-chart v-if="dailyChartData.labels.length" :chart-data="dailyChartData" :options="chartOptions" :height="250" />
          <div v-else class="text-center py-5 text-muted">Không đủ dữ liệu để hiển thị biểu đồ</div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card h-100">
        <div class="card-header bg-white font-weight-bold">
          <i class="fas fa-chart-pie mr-1"></i> Doanh thu theo danh mục
        </div>
        <div class="card-body">
          <bar-chart v-if="categoryChartData.labels.length" :chart-data="categoryChartData" :options="categoryChartOptions" :height="250" />
          <div v-else class="text-center py-5 text-muted">Không có dữ liệu</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Line, Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

const LineChart = {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}

const BarChart = {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}

export default {
  name: 'RevenueChart',
  components: { LineChart, BarChart },
  props: {
    reportDailyRevenue: Array,
    reportByCategory: Array
  },
  computed: {
    dailyChartData() {
      return {
        labels: this.reportDailyRevenue.map(d => d.date),
        datasets: [
          {
            label: 'Doanh thu',
            borderColor: '#304ffe',
            backgroundColor: 'rgba(48, 79, 254, 0.1)',
            data: this.reportDailyRevenue.map(d => d.revenue),
            fill: true
          },
          {
            label: 'Lợi nhuận',
            borderColor: '#28a745',
            backgroundColor: 'transparent',
            data: this.reportDailyRevenue.map(d => d.profit),
            fill: false
          }
        ]
      }
    },
    categoryChartData() {
      return {
        labels: this.reportByCategory.map(c => c.categoryName),
        datasets: [
          {
            label: 'Doanh thu',
            backgroundColor: ['#304ffe', '#28a745', '#ffc107', '#17a2b8', '#dc3545', '#6c757d'],
            data: this.reportByCategory.map(c => c.revenue)
          }
        ]
      }
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function(value) {
                return value.toLocaleString() + '₫';
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toLocaleString() + '₫';
            }
          }
        }
      },
      categoryChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function(value) {
                return value.toLocaleString() + '₫';
              }
            }
          }]
        }
      }
    }
  }
};
</script>
